import { InternalUserActivationStatus } from "types/enum";

import {
    type IInternalUserStatusData,
    type IUserStatus,
} from "entity/internalUser/InternalUserDetails/InternalUser.api.types";

export const getUserStatusMappings = (
    entity: IInternalUserStatusData,
    noInfoType?: boolean,
): IUserStatus => {
    if (entity.activationStatus === InternalUserActivationStatus.ActiveInviteAccepted) {
        return {
            statusType: "success",
            statusMessage: "Active",
            statusDate: entity.accountConfirmationDate,
        };
    } else if (entity.activationStatus === InternalUserActivationStatus.ActiveInvitePending) {
        return {
            statusType: "pending",
            statusMessage: "Invite Pending",
            statusDate: entity.invitationDate,
        };
    } else if (entity.activationStatus === InternalUserActivationStatus.Archived) {
        return {
            statusType: "",
            statusMessage: "Archived",
        };
    } else if (entity.activationStatus === InternalUserActivationStatus.ActiveNoInvite) {
        return {
            statusType: noInfoType ? "" : "info",
            statusMessage: "Not Invited",
        };
    } else {
        return {
            statusType: "",
            statusMessage: "Inactive",
        };
    }
};
